import { Box, Button, Divider, Flex, Image, LoadingOverlay, SimpleGrid, Space, Text, Title, Tooltip } from '@mantine/core';
import React, { memo, useContext, useEffect, useState } from 'react';
import DataPieChart from './PieChart/PieChart.component';
import LcaTableComponent from './LcaTable/LcaTable.component';
import useFetch from '../../../../../Customhooks/useFetch';
import { baseUrl } from '../../../../../Constants/constant';
import { authContext } from '../../../../../context/AuthProvider.component';
import { FaRegArrowAltCircleDown } from 'react-icons/fa';
import ReportPdf from '../../../../../CustomComponent/DownloadPdfReport/ReportPdf.component';
import { useDisclosure } from '@mantine/hooks';

interface LcaReportProps { }

interface CustomerData {
  icon_name: string;
  // Add other properties as needed
}

interface LcaData {
  product_name: string;
  product_description: string;
  Customer: CustomerData;
  created_at: any;
  value: string;
  id: any;
  DatabaseVersion: any;
  ComputeCommentLogo: any;
  product_image: any;
  report_name: string;
  // Add other properties as needed
}

const LcaReport: React.FC<LcaReportProps> = () => {
  const { computeId } = useContext<any>(authContext);
  const [confirmPdfOpened, { open: openConfirmPdf, close: closeConfirmPdf }] = useDisclosure(false);
  const updatedUrl = baseUrl.replace("/api/", "");
  const token = localStorage.getItem("token");
  // const [imageUrl, setImageUrl] = useState<string[]>([]);

  const { data: datalist, loading: listLoading, error: getlistError, fetchData: gettable } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      token: token,
    },
  });

  // const {
  //   data: Base64Data,
  //   error: resError,
  //   fetchData: fetchBaseString
  // } = useFetch({
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json",
  //     token: token,
  //   },
  //   body: JSON.stringify({
  //     images: imageUrl
  //   })
  // });

  useEffect(() => {
    if (computeId) {
      gettable(`${baseUrl}compute/lca/calculateLca/${computeId}`);
    }
  }, [computeId]);

  // useEffect(() => {
  //   if (datalist?.data?.data[0]?.Customer?.icon_name) {
  //     const customerIcon = `${datalist?.data?.data[0]?.ComputeCommentLogo?.ComputeCustomerLogo?.icon_name}`;
  //     const verticalIcon = datalist?.data?.data[0]?.product_image;
  //     const images: any = [
  //       customerIcon ? `${updatedUrl}${customerIcon}` : null,
  //       verticalIcon ? `${updatedUrl}${verticalIcon}` : null
  //     ].filter(Boolean); // removes nulls

  //     if (images.length > 0) {
  //       setImageUrl(images);
  //     }
  //   }
  // }, [datalist, updatedUrl]);


  // useEffect(() => {
  //   if (imageUrl.length > 0) {
  //     fetchBaseString(`${baseUrl}compute/lca/loadImages`);
  //   }
  // }, [imageUrl]);

  const data: LcaData | undefined = datalist?.data?.data[0];

  const handleDownloadPDF = () => {
    openConfirmPdf();
  };

  if (getlistError) {
    return <Box><Text color="red">Error loading LCA data. Please try again later.</Text></Box>;
  }

  return (
    <>
      <LoadingOverlay
        visible={listLoading}
        zIndex={1000}
        overlayProps={{
          radius: 'sm',
          blur: 2,
          style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }
        }}
        loaderProps={{ color: '#404040', type: 'bars' }}
      />
      <Space h="lg" />
      <Flex
        gap="md"
        justify="space-between"
        align="center"
        direction="row"
        wrap="wrap"
      >
        <Title order={2}>Report</Title>
        <Tooltip label="Download Lca Report" color="#404040">
          <Button
            variant="filled"
            onClick={handleDownloadPDF}
            size='md'
            styles={{
              root: {
                backgroundColor: '#404040',
                '&:hover': {
                  backgroundColor: '#505050'
                }
              }
            }}
          >
            <FaRegArrowAltCircleDown size={30} />
          </Button></Tooltip>
      </Flex>
      <Space h="lg" />
      <Divider />
      <Space h="lg" />

      {data ? (
        <Box>
          <Box style={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
            <Box style={{ marginLeft: '12px', width: '70%' }}>
              <Text size='xl' fw={700}>PRODUCT LIFECYCLE ASSESSMENT</Text>
              <Space h="xs" />
              <Box pl={20}>
                <Title order={4} tt="uppercase">REPORT NAME: {data.report_name}</Title>
                <Title order={4} tt="uppercase">PRODUCT NAME: {data.product_name}</Title>
                <Title order={4} tt="uppercase">DATABASE VERSION: {data?.DatabaseVersion?.db_version}</Title>
                <Box w={350} mt={24}>
                  <Text size="xl" lh={1} component='div'
                    style={{
                      wordBreak: 'break-all',
                      whiteSpace: 'normal',
                    }}
                  >
                    <Title
                      order={4}
                      style={{ display: 'inline', textTransform: 'uppercase', marginRight: 4 }}
                    >
                      DESCRIPTION :
                    </Title>{data.product_description}
                  </Text>
                </Box>
              </Box>
            </Box>
            <Box>
              <Box style={{ width: '50%' }}>
                <Box>
                  {data.ComputeCommentLogo?.ComputeCustomerLogo?.icon_name?.length > 0 && <Image
                    fit="contain"
                    src={`${updatedUrl}${data.ComputeCommentLogo?.ComputeCustomerLogo?.icon_name}`}
                    alt={`Customer logo`}
                    // onLoad={(e) => handleImageLoad(e, index)}
                    style={{ width: '100px' }}
                  />}
                  {data?.product_image?.length > 0 && <Image
                    fit="contain"
                    src={`${updatedUrl}${data?.product_image}`}
                    alt={`Customer logo`}
                    // onLoad={(e) => handleImageLoad(e, index)}
                    style={{ width: '100px' }}
                  />}
                </Box>
              </Box>
            </Box>
          </Box>
          <SimpleGrid
            cols={{ base: 1, sm: 1, lg: 2 }}
          >
            <Box style={{ width: '100%' }}><LcaTableComponent data={data} /></Box>
            <Box style={{ width: '100%' }}><DataPieChart data={data} /></Box>
          </SimpleGrid>
        </Box>
      ) : (
        <Box py="xl" ta="center">
          <Text>Loading report data...</Text>
        </Box>
      )}
      <ReportPdf
        isConfirmOpen={confirmPdfOpened}
        closeConfirm={closeConfirmPdf}
        id={computeId}
      />
    </>
  );
};

export default memo(LcaReport);